import { RSAA } from 'redux-api-middleware';

export const USERTYPES_IS_FETCHING = 'USERTYPES_IS_FETCHING';
export const USERTYPES_GET_SUCCESS = 'USERTYPES_GET_SUCCESS';
export const USERTYPES_GET_ERROR = 'USERTYPES_GET_ERROR';

// Initial State
export const initialState = {
  defaultSearchParams: {
    perPage: 1000,
    page: 1
  },
  isFetching: false,
  items: [],
  error: null
};

// Actions
export const getUserTypesList = queryString => {
  return {
    [RSAA]: {
      controlKey: 'CTRL_USERTYPE',
      controlAction: 'collection',
      queryString,
      types: [
        USERTYPES_IS_FETCHING,
        {
          type: USERTYPES_GET_SUCCESS,
          meta: { ...queryString }
        },
        USERTYPES_GET_ERROR
      ]
    }
  };
};

// Reducer
export default (state = initialState, action) => {
  switch (action.type) {
    case USERTYPES_IS_FETCHING:
      return { ...state, isFetching: true, error: null };

    case USERTYPES_GET_SUCCESS:
      return {
        ...state,
        isFetching: false,
        error: null,
        items: action.payload
      };

    case USERTYPES_GET_ERROR:
      return {
        ...state,
        isFetching: false,
        error: action.payload
      };

    default:
      return state;
  }
};
